var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStackoverflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-so-2 {\n        fill: #f48024;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stickers"
  }, /*#__PURE__*/React.createElement("path", {
    id: "stackoverflow",
    className: "cls-so-2",
    d: "M565.86,737.48c-23.84-2.61-47.48,14.67-52.79,38.59s9.7,45.43,33.54,48,47.47-14.66,52.79-38.59S589.69,740.09,565.86,737.48ZM552.15,766.7,568,779.54l-3.17,3.66L549,770.37ZM545,776.63l19.29,7.78-2.15,4.27-19.29-7.78ZM541,786l20.72,4.27-1.42,4.49-20.72-4.27Zm-2.43,7.69L559.8,796l-1,4.55-21.25-2.33Zm26.1,13.81s-.24,1.07-.27,1.07h0l-34-3.72-1.06-.13h0l4.93-22.18,3.62.4-4.13,18.61,27.87,3.05L565.72,786l3.63.4ZM569,778.8,561,759.88l4.32-2.15,8.05,18.92Zm5.22-2.31,1-21.41,4.64-.29-1,21.41Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackoverflow);
export default __webpack_public_path__ + "static/media/stackoverflow.e12e9191204b5bc00af00b9da2c461ef.svg";
export { ForwardRef as ReactComponent };